export default {
  // 签名秘钥
  signSecret: '916lWh2WMcbSWiHv',
  // 密码正则
  passwordReg: /^(?=(?:.*[A-Z]))(?=(?:.*[a-z]))(?=(?:.*\d))[A-Za-z\d]{8,16}$|^(?=(?:.*[A-Z]))(?=(?:.*[a-z]))(?=(?:.*[\W_]))[A-Za-z\W_]{8,16}$|^(?=(?:.*[A-Z]))(?=(?:.*\d))(?=(?:.*[\W_]))[A-Z\d\W_]{8,16}$|^(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[\W_]))[a-z\d\W_]{8,16}$|^(?=(?:.*[A-Z]))(?=(?:.*[a-z]))(?=(?:.*\d))(?=(?:.*[\W_]))[A-Za-z\d\W_]{8,16}$/,
  passwordRegDesc: '密码至少需要包含大写字母、小写字母、数字、特殊字符四种字符里的三种,长度为8-16位 ',
  userUploadUrl: `${process.env.VUE_APP_API_ROOT}/user/file/upload`,
  // 启用微信功能
  enableWx: process.env.VUE_APP_WX == 'ON'
}
